export default __webpack_public_path__ + "static/media/minus.a96f8ec2.svg";